// export const isAuthenticated = state=>state.auth.isAuthenticated;
// export const getUserStatus = state=>state.auth.authStatus;
//auth
export const isAuthenticated = state => state.auth.isAuthenticated;
export const isCheckUserInProgress = state => state.auth.checkUserInProgress;
export const getUserInfo = state => state.auth.userInfo;
export const getAutoRedirect = state => state.auth.autoRedirect;
export const get2FaStatus = state =>state.auth.using2Fa;
export const getLoginPassedStatus = state=>state.auth.loginPassed;
// global data
export const installationSelect = state => state.globalData.installationSelect;
export const reloadTableView = state => state.globalData.reloadTableView;
export const getActiveTab = state => state.globalData.activeTab;
export const TwoFAModalState = state => state.globalData.show2FAModal;
// installations
export const getAllInstallationsItem = state => state.installations
export const getInstallations = state => state.installations.installationsItem;
export const modalVisibility = state => state.installations.modalVisible
export const editDataInstallation = state => state.installations.editInstallation
export const checkIsUpdate = state => state.installations.isUpdate
export const deleteItemConfirmation = state => state.installations.deleteConfirmation
export const idMOdalForDelete = state => state.installations.idModal
export const installationsLoader = state => state.installations.appLoader
export const installationsLoad = state => state.installations.isLoading;
export const getInstallationsPagination = state => state.installations.pagination;
export const getAllInstallationsWithoutPag = state => state.installations.allInstallations

//notification
export const showMessageNotificationGlobal = state => state.notificationMessage.showMessage
export const messageNotificationGlobal = state => state.notificationMessage.message
export const typeNotificationGlobal = state => state.notificationMessage.notificationStatus
export const titleNotificationGlobal = state => state.notificationMessage.title

//map
export const getLocation = state => state.map.location;
export const getLocations = state => state.map.locations;
export const getModalStatus = state => state.map.showModal;
export const getLocationEdit = state => state.map.editing;
export const getLocationLoader = state => state.map.loading;
export const getLocationsPagination = state => state.map.pagination;
export const getLocationTableData = state => state.map.locationTableData;
export const getLocationAlarms = state => state.map.alarms;
export const getCommandsModalStatus = state => state.map.showCommandsModal;
export const getAlarmsHistory = state => state.map.alarmsHistory;
export const getAlarmsModalStatus = state => state.map.showAlarmsModal;
export const getConfiguredAlarms = state => state.map.alarmsConfig;
export const getConfiguredAlarmsLoading = state => state.map.alarmsConfigLoading;

//alarms
export const getAlarms = state => state.alarms.alarmsList;
export const getAlarmsLoading = state => state.alarms.loading;
export const getAlarmsPagination = state => state.alarms.pagination;
export const getActiveAlarms = state => state.alarms.activeAlarms;
export const getActiveAlarmsLoading = state => state.alarms.activeAlarmsLoading;
export const getActiveAlarmsPagination = state => state.alarms.activeAlarmsPagination;
export const getAlarmsConfig = state => state.alarms.alarmsConfig;
export const getAlarmsConfigLoading = state => state.alarms.alarmsConfigLoading;
export const getAlarmsConfigPagination = state => state.alarms.alarmsConfigPagination;

//device
export const getDevices = state => state.device.devices;
export const getDeviceLoader = state => state.device.loading;
export const getDeviceModalStatus = state => state.device.showModal;
export const getDeviceTypes = state => state.device.deviceTypes;
export const getDevice = state => state.device.device;
export const getDeviceEdit = state => state.device.editing;
export const getDeviceDeleteModalStatus = state => state.device.showDeviceDeleteModal;
//triggers
export const getAllTriggers = state => state.triggers.triggersItem
export const getTriggersPagination = state => state.triggers.pagination;
export const modalVisibilityTrigger = state => state.triggers.modalVisible
export const getAllInstructions = state => state.triggers.instructionsData
export const getAllDevicesByInstallationId = state => state.triggers.devicesItemById;
export const getAllLocationsByInstallationId = state => state.triggers.locationItemById;
export const getAllLocationItem = state => state.triggers.allLocationItem;
export const getAllInstructionsPaggination = state => state.triggers.paginationInstructions
export const deleteItemInstConfirmation = state => state.triggers.deleteConfirmation
export const idMOdal = state => state.triggers.idModal
export const modalVisibilityTriggerInstruction = state => state.triggers.modalVisibleInstruction
export const editDataInstruction= state => state.triggers.editInstruction
export const checkIsUpdateInstruction = state => state.triggers.isUpdateInstruction
export const triggersLoader = state => state.triggers.appLoader
export const deleteItemTriggerConfirmation = state => state.triggers.deleteConfirmationTriggers
export const checkIsUpdateTrigger = state => state.triggers.isUpdateTrigger
export const editTriggerItem = state => state.triggers.editTrigger

//users
export const getAllUsersItem = state => state.users.allUsers
export const getUsersPagination = state => state.users.pagination;
export const getUsersLoading = state => state.users.isLoading;

//notes
export const getNotesArray = state => state.notes.notesArray;
export const getNotesLoading = state => state.notes.loading;
export const getNotesPagination = state => state.notes.pagination;
export const getNotesModalStatus = state => state.notes.showModal;
export const getNotesDeleteModalStatus = state => state.notes.showDeleteModal;

//dynamic table
export const installationSelectData = state => state.dynamicTable.installationSelect
export const locationsSelectData = state => state.dynamicTable.installationLocationsSelect
export const allDevicesSelectData = state => state.dynamicTable.allDevicesSelect
export const dynamicTableList = state => state.dynamicTable.tableList
export const dynamicTableListLoading = state => state.dynamicTable.tableListLoading
export const showCreateModal = state => state.dynamicTable.showCreateModal
export const showDeleteModal = state => state.dynamicTable.deleteModals
export const showAddRowModal = state => state.dynamicTable.addRowModals
export const showAddColumnModal = state => state.dynamicTable.addColumnModals
export const uniqueDeviceTypes = state => state.dynamicTable.deviceParams
export const getDynamicTableById = (id) => (state) => state.dynamicTable.tableList.find(table => table.id === id);
